import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Field, Input, Button } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const Edit = ({ feature, onClose, onSave, show }) => {
  const [data, setData] = useState({});
  const [error, setError] = useState(false);

  useEffect(() => {
    const new_feature = feature || {};

    setData({
      id: new_feature.id,
      name: new_feature.name || ''
    });
  }, [feature]);

  const handleNameChange = e => {
    setData({ ...data, name: e.target.value });
  };

  const handleSave = () => {
    if (data.name) {
      const { id, ...payload } = data;

      setError(false);

      Api.saveProductFeature(id, payload).then(() => {
        onSave();
      });
    } else {
      setError(true);
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>{data.id ? 'Save Changes' : 'Create New Feature'}</Button>
      }
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Feature' : 'New Feature'}
    >
      <Field label='Name'>
        <Input invalid={error} onChange={handleNameChange} required={true} value={data.name} />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  feature: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default Edit;
